import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'esgStatus' })
export class EsgStatusPipe implements PipeTransform {
    transform(text: string) {
        switch (text) {
            case 'BEGINNER':
                return 'Iniciante';
            case 'ADVANCED':
                return 'Avançado';
            case 'INTERMEDIATE':
                return 'Intermediário';
            default:
                return '---';
        }
    }
}
